export default __webpack_public_path__ + "static/media/wheelchairAccess.930a1573.svg";